import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = { atTop: true };
  }

  componentDidMount() {
    this.handleScroll = () => {
      this.setState({ atTop: window.scrollY < 50 });
    };
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const navClass = "navbar navbar-default navbar-fixed-top" + (this.state.atTop ? " navbar-transparent" : "");
    return (
      <nav className={navClass}>
        <div className="container">
            <div className="navbar-header">
                <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                </button>
                <Link to="/" className="navbar-brand" >vspace.one</Link>
            </div>
            <div className="collapse navbar-collapse" id="myNavbar">
                <ul className="nav navbar-nav navbar-right">
                    <li className="dropdown">
                        <a href="/" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Home<span className="caret"></span></a>
                        <ul className="dropdown-menu">
                            <li><a href="/#Mitmachen">Mitmachen</a></li>
                            <li><a href="/#Ausstattung">Ausstattung</a></li>
                            <li><a href="/#Ort">Ort</a></li>
                        </ul>
                    </li>

                    <li className="dropdown">
                        <a href="/mitgliedwerden" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Unterstützen<span className="caret"></span></a>
                        <ul className="dropdown-menu">
                            <li><Link to="/mitgliedwerden">Mitglied werden</Link></li>
                            <li><Link to="/spenden">Spenden</Link></li>
                            <li><Link to="/sponsoren">Sponsoren</Link></li>
                        </ul>
                    </li>

                    <li><a href="https://wiki.vspace.one">Wiki</a></li>

                    <li className="dropdown">
                      <a href="/freunde" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Social<span className="caret"></span></a>
                      <ul className="dropdown-menu">
                        <li><a href="https://t.me/joinchat/DmNdswpnKgox_zzqENYXiA" target="_blank" rel="noopener noreferrer"><i className="fab fa-telegram"></i> Telegram</a></li>
                        <li><a href="https://matrix.to/#/#vspaceone-general:matrix.org" target="_blank" rel="noopener noreferrer"><img src="/pic/logos/Matrix.svg" style={{width: "16px", height: "16px", verticalAlign: "middle", marginRight: "6px"}} alt="Matrix" /> Matrix</a></li>
                        <li className="divider"></li>
                        <li><a href="https://www.instagram.com/vspace.one/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i> Instagram</a></li>
                        <li><a href="https://chaos.social/@vspaceone" target="_blank" rel="noopener noreferrer"><i className="fab fa-mastodon"></i> Mastodon</a></li>
                        <li><a href="https://www.facebook.com/vspace.one" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i> Facebook</a></li>
                        <li><a href="https://twitter.com/vspaceone" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i> Twitter</a></li>
                        <li className="divider"></li>
                        <li><Link to="/freunde"><i className="fas fa-handshake"></i> Partner</Link></li>
                        <li><a href="https://easyverein.com/public/vspaceone/?next=profile" target="_blank" rel="noopener noreferrer"><i className="fas fa-user-circle"></i> EasyVerein</a></li>
                      </ul>
                    </li>
                    <li>
                        <NavState state={ this.props.state } />
                    </li>
                </ul>
            </div>
        </div>
      </nav>
    );
  }
}

class NavState extends Component {
  render(){

    //const open = true;
    var classes = "label doorstatelabel "
    var stateText = "Loading"

    if (this.props.state === undefined){
        classes += "label-warning"
        stateText = "defect"
    } else if (this.props.state.open){
        classes += "label-success"
        stateText = "open"
    } else {
        classes += "label-danger"
        stateText = "closed"
    }

    return(
        <div id="doorstate" className={classes}>
            <a href="#state" id="doorstateString">{stateText}</a>
        </div>
    );
  }
}

export default Nav;
